export const FETCH_USER_IMAGES_JOBS_REQUEST = 'FETCH_USER_IMAGES_JOBS_REQUEST';
export const FETCH_USER_IMAGES_JOBS_SUCCESS = 'FETCH_USER_IMAGES_JOBS_SUCCESS';
export const FETCH_USER_IMAGES_JOBS_FAILURE = 'FETCH_USER_IMAGES_JOBS_FAILURE';
export const FLUSH_JOBS_STATE = 'FLUSH_JOBS_STATE';

